import Home from '../components/Home';
import About from '../components/About';
import Services from '../components/Services';
import Contact from '../components/Contact';
import Product from '../components/Product';
import TechnologyStack from '../components/TechnologyStack';
import SEO from '../components/SEO';
import AEOFAQ from '../components/AEOFAQ';

const HomePage = () => {
    return (
        <div>
            <SEO
                title="Anmatics | SaaS, AI Workflow & Enterprise Software Engineering"
                description="Anmatics builds SaaS platforms, AI workflow automation, enterprise web applications, cloud APIs, and legacy modernization solutions for companies that need reliable software engineering."
                path="/"
            />
            <Home />
            <About />
            <Services />
            <TechnologyStack />
            <Product />
            <AEOFAQ />
            <Contact />
        </div>
    )
}

export default HomePage;
